import PropTypes from "prop-types";

// MUI
import { Box } from "@mui/material";
import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import CommonToolbar from "@/Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";

export default function MyIncentivesTable(props) {
	const { incentive = "", loading = false, data = [], options } = props;
	const apiRef = useGridApiRef();

	return (
		<Box className="pt-[30px] h-full">
			{loading ? (
				<TableLoader toolbarSx={{ marginBottom: "0.9rem" }} toolbar multiTitles={5} rows={4} content buttons={2} />
			) : (
				<DataSmartTable
					apiRef={apiRef}
					columns={options[incentive].column}
					rows={data}
					headerHeight={40}
					rowHeight={25}
					enableCustomScrollbars
					hideFooter
					autoHeight={false}
					maxRows={15}
					disableSelectionOnClick
					checkboxSelection={false}
					columnVisibilityModel={{
						id: false,
						_id: false,
					}}
					slots={{
						toolbar: CommonToolbar,
						noRowsOverlay: NoRowsOverlay,
					}}
					slotProps={{
						toolbar: {
							filter: {
								hide: false,
							},
							search: {
								data: data || [],
								hide: false,
								disabled: false,
							},
						},
						noRowsOverlay: {
							title: `No ${options[incentive].title} Found`,
						},
					}}
					customProps={{
						tableClassName: {
							"functional-table": true,
						},
						hide: false,
					}}
				/>
			)}
		</Box>
	);
}
MyIncentivesTable.propTypes = {
	incentive: PropTypes.string.isRequired,
	loading: PropTypes.bool,
	data: PropTypes.array,
	options: PropTypes.object,
};
